module.exports = __webpack_public_path__ + "static/media/resizeMessageBox.aa6b07c5.svg";